<template lang="pug">
.album-wrap
  .header
    h2.title {{content.homeSectionName}}
    a.right-arrow(target="_blank" :href="localePath('/collection/' + `${content.websiteParam||content.refId}`+`?section=${content.homeSectionId}&name=${content.homeSectionName}`)"  @click="handleBury('album')")
      | {{$t('indexPage.more')}}
      i.iconfont.icon-arrow1_s
  .list
    a.video-item(v-for='(item, index) in content.recommendContentVOList', :key='index', target="_blank", v-if="type === 0 ? index < 6 : index < 12", :href="localePath('/detail/'+ $semantic.type[item.category] + '/' + `${item.websiteParam||item.id}`+`?section=${content.refId}&sectionName=${content.homeSectionName}&sequence=${sequence}`)" @click="handleBury('video',item)")
      video-card(:title='item.title', :img='item.imageUrl' :mark='false' :type="content.coverType === 1 ? 'vertical' : 'horizontal'")
</template>

<script>
export default {
  name: 'Album',
  props: {
    content: {
      type: Object,
      default: () => {}
    },
    type: {
      type: Number,
      // 0 展示6个， 1展示 12个
      default: 0
    },
    sequence: {
      // 板块顺序 埋点用
      type: Number,
      default: 0
    }
  },
  methods: {
    handleBury(type, item) {
      this.$LokBury.handleMD(
        {
          buryEventId: 'UM_Event_ContentClick',
          buryParams: {
            UM_Key_ContentName: type === 'album' ? this.content.homeSectionName : item.title,
            UM_Key_ContentID: type === 'album' ? this.content.refId : item.id,
            UM_Key_ContentType: type === 'album' ? '片单' : this.$semantic.cnName[item.category],
            UM_Key_SourceSection: `${this.content.homeSectionId}#@#${this.content.homeSectionName}`,
            UM_Key_SourceLocation: this.sequence
          }
        },
        'click'
      )
    }
  }
}
</script>

<style scoped lang="sass">

.album-wrap
  padding-left: 20px
  padding-right: 20px
  margin-bottom: 40px
  .header
    height: 40px
    margin-bottom: 12px
    display: flex
    justify-content: space-between
    align-items: center
    .title
      font-size: 24px
      line-height: 120%
      color: $mainTextColor
    .right-arrow
      font-size: 18px
      color: $mainTextColor
      font-weight: 900
      line-height: 40px
      padding-left: 30px
      padding-right: 26px
      background: $backgroundColor1
      border-radius: 48px
      user-select: none
      span
        vertical-align: middle
      i
        margin-left: 8px
        font-size: 14px
        vertical-align: top
    .right-arrow:hover
      color: $mainColor
  .list
    display: flex
    flex-wrap: wrap

    .video-item
      width: 15.32%
      flex-shrink: 0
      margin-right: 1.61%
      text-decoration: none
      margin-bottom: 20px
      img
        width: 100%
        height: 300px
        border-radius: 8px
      .title
        font-size: 16px
        color: #81868E
        letter-spacing: 0
        line-height: 24px
    .video-item:nth-child(6n+6)
      margin-right: 0
@media screen and (max-width: 1140px)
@media screen and (max-width: 960px)

@media screen and (max-width: 750px)
  .album-wrap
    padding-left: 16px
    padding-right: 16px
    margin-bottom: 24px
    .list
      @include base-flex
      flex-wrap: wrap
      padding-left: 0px
      padding-right: 0px
      a
        text-decoration: none
      .video-item
        width: calc( (100% - 20px) / 3 )
        flex-shrink: 0
        margin-right: 10px
        img
          width: 100%
          height: 300px
          border-radius: 8px
        .title
          font-size: 16px
          color: #81868E
          letter-spacing: 0
          line-height: 24px
      .video-item:nth-child(3n+3)
        margin-right: 0
</style>
